import React from 'react';
import './CopySuccessModal.css';

const CopySuccessModal = ({ isOpen, onClose, copyType }) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  const isSignature = copyType === 'signature';
  const title = isSignature ? 'Signature copiée !' : 'Code source copié !';
  const description = isSignature 
    ? 'Votre signature a été copiée dans le presse-papier. Vous pouvez maintenant la coller directement dans votre client de messagerie.'
    : 'Le code HTML de votre signature a été copié dans le presse-papier. Vous pouvez maintenant le coller dans les paramètres de signature de votre client email.';

  return (
    <div className="copy-modal-backdrop" onClick={handleBackdropClick}>
      <div className="copy-modal-content">
        <div className="copy-modal-header">
          <div className="copy-success-icon">✅</div>
          <h3>{title}</h3>
          <button className="copy-modal-close" onClick={onClose}>
            ✕
          </button>
        </div>
        
        <div className="copy-modal-body">
          <p className="copy-modal-description">
            {description}
          </p>
          
          <div className="copy-modal-tips">
            <h4>💡 Instructions d'installation :</h4>
            <ul>
              <li><strong>Gmail :</strong> Paramètres → Général → Signature → Coller avec Ctrl+V</li>
              <li><strong>Outlook :</strong> Fichier → Options → Courrier → Signatures → Coller avec Ctrl+V</li>
              <li><strong>Apple Mail :</strong> Préférences → Signatures → Coller avec Cmd+V</li>
              <li><strong>Thunderbird :</strong> Paramètres → Paramètres des comptes → Signature → Coller avec Ctrl+V</li>
            </ul>
            
            <div className="copy-modal-additional-tips">
              <h5>📋 Conseils supplémentaires :</h5>
              <ul>
                <li>Testez votre signature en vous envoyant un email</li>
                <li>Vérifiez l'affichage sur mobile et desktop</li>
                <li>Les images doivent être hébergées en ligne (Google Photos, Dropbox, etc.)</li>
                <li>Évitez les polices trop exotiques pour une meilleure compatibilité</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="copy-modal-actions">
          <button className="btn btn-primary" onClick={onClose}>
            Parfait !
          </button>
        </div>
      </div>
    </div>
  );
};

export default CopySuccessModal;